export enum ONBOARDING_FLOW_STATE {
  PRE_4 = 'pre_4',
  PRE_5 = 'pre_5',
  PRE_COMPLETE = 'pre_complete',
  POST_1 = 'post_1',
  POST_2 = 'post_2',
  POST_3 = 'post_3',
  POST_4 = 'post_4',
  POST_5 = 'post_5',
  COMPLETE = 'complete',
}
